const E = {
  Samples: 'Samples',
  Parameters: 'Parameters',
  'Job Files': 'Job Files',
  Observations: 'Observations',

  'Project Number': 'Project Number',
  'Site Location': 'Site Location',
  'Site Number': 'Site Number',
  'PO Number': 'PO Number',
  'Task Order': 'Task Order',
  Received: 'Received',
  Confirmed: 'Confirmed',
  'Job Due': 'Job Due',
  Status: 'Status',
  'Criteria 1': 'Criteria 1',
  'Criteria 2': 'Criteria 2',
  'Exceedance(s)': 'Exceedance(s)',
  'COC#s': 'COC#s',
  'Report To': 'Report To',
  'Invoice To': 'Invoice To',
  'Line Item': 'Line Item',
  'Cost Object': 'Cost Object',

  COC: 'COC',
  Confirmation: 'Confirmation',
  'Partial Report': 'Partial Report',
  'Final Report': 'Final Report',
  Attention: 'Attention',
  'We couldn’t find any samples(s) that match your selected job&#46;':
    'We couldn’t find any samples(s) that match your selected job.',
  NoParameters:
    'We couldn’t find any parameter(s) that match your selected job.',
  'If you need assistance, please contact your Bureau Veritas representative&#46;':
    'If you need assistance, please contact your Bureau Veritas representative.',
  'There are no files currently available for this job':
    'There are no files currently available for this job.',
  'Job Number': 'Job Number',

  1: {
    samples:
      'Please note that the Customer Portal compares criteria values to data that has not been rounded based on significant digits. This may cause the exceedance count to be higher than the actual number of exceedances reported in the certificate of analysis.',
    parameters:
      'Although validated, results are preliminary and therefore subject to change. Please refer to the certificate of analysis for final results, QC data and applicable comments.',
  },
  2: {
    parameters:
      'Please note that the Customer Portal compares criteria values to data that has not been rounded based on significant digits. This may cause the exceedance count to be higher than the actual number of exceedances reported in the certificate of analysis.',
  },
  Number: 'Number',
  Description: 'Description',
  NoObservations:
    'We couldn’t find any observations(s) that match your selected job.',
  info1:
    '¹ Although validated, results are preliminary and therefore subject to change. Please refer to the certificate of analysis for final results, QC data and applicable comments.',
  info2:
    '² Please note that the Customer Portal compares criteria values to data that has not been rounded based on significant digits. This may cause the exceedance count to be higher than the actual number of exceedances reported in the certificate of analysis.',
};

const F = {
  'Line Item': 'No de ligne',
  'Cost Object': 'Objet de coût',
  Samples: 'Échantillons',
  Parameters: 'Paramètres',
  'Job Files': 'Dossiers d’analyse',
  Observations: 'Observations',
  NoObservations: 'Aucune observation ne correspond au dossier sélectionné.',
  'Project Number': 'Numéro de projet',
  'Site Location': 'Emplacement du site',
  'Site Number': 'Numéro de site',
  'PO Number': 'No de bon de commande',
  'Task Order': 'No d’engagement',
  Received: 'Reçu',
  Confirmed: 'Confirmé',
  'Job Due': 'Échéance du dossier atteinte',
  Status: 'Statut',
  'Criteria 1': 'Critère 1',
  'Criteria 2': 'Critère 2 ',
  'Exceedance(s)': 'Dépassement',
  'COC#s': 'No de CDR',
  'Report To': 'Envoyer rapport à',
  'Invoice To': 'Envoyer facture à',
  Attention: 'À l’attention de',

  'Job Number': 'Numéro de dossier',

  COC: 'CDR',
  Confirmation: 'Confirmation',
  'Partial Report': 'Rapport partiel',
  'Final Report': 'Rapport final',
  'We couldn’t find any samples(s) that match your selected job&#46;':
    'Aucun Échantillons ne correspond au dossier sélectionné.',
  NoParameters: 'Aucun paramètre ne correspond au dossier sélectionné.',
  'If you need assistance, please contact your Bureau Veritas representative&#46;':
    'Si vous avez besoin d’aide, veuillez contacter votre représentant des Lab BV.',
  'There are no files currently available for this job':
    'Aucun fichier disponible dans ce dossier pour le moment.',

  1: {
    samples:
      'Prendre note que le portail client compare la valeur des critères aux données qui n’ont pas été arrondies aux chiffres significatifs. Le nombre de dépassements peut donc être supérieur à celui indiqué sur le certificat d’analyse.',
    parameters:
      'Bien qu’ils soient validés, il s’agit de résultats préliminaires et peuvent donc changer. Veuillez vous référer au certificat d’analyse pour les résultats finaux, les données relatives au CQ et les commentaires applicables.',
  },
  2: {
    parameters:
      'Prendre note que le portail client compare la valeur des critères aux données qui n’ont pas été arrondies aux chiffres significatifs. Le nombre de dépassements peut donc être supérieur à celui indiqué sur le certificat d’analyse.',
  },
  Number: 'Numéro',
  Description: 'Description',
  info1:
    '¹ Bien qu’ils soient validés, il s’agit de résultats préliminaires et peuvent donc changer. Veuillez vous référer au certificat d’analyse pour les résultats finaux, les données relatives au CQ et les commentaires applicables.',
  info2:
    '² Prendre note que le portail client compare la valeur des critères aux données qui n’ont pas été arrondies aux chiffres significatifs. Le nombre de dépassements peut donc être supérieur à celui indiqué sur le certificat d’analyse.',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/jobsDetail.js